// config/wsParserConfig.js

export const PARSER_TOPICS = {
  // App destinations (to send to backend)
  APP_ENDPOINT_BASE: '/app/parser',
  APP_START: '/start',
  APP_STOP: '/stop',
  APP_EXPORT: '/export',

  // User queue topics (to receive from backend)
  USER_QUEUE_BASE: '/user/queue/parser',
  USER_PROGRESS: '/progress',
  USER_RESULT: '/result',
  USER_ERROR: '/error',
};

export const PARSER_MESSAGE_TYPES = {
  // Status updates
  STATUS_UPDATE: 'STATUS_UPDATE',
  PROGRESS_UPDATE: 'PROGRESS_UPDATE',
  
  // Results
  PARSING_STARTED: 'PARSING_STARTED',
  SERVER_FOUND: 'SERVER_FOUND',
  SERVERS_FOUND_BATCH: 'SERVERS_FOUND_BATCH', // New batch message type
  PARSING_COMPLETED: 'PARSING_COMPLETED',
  PARSING_STOPPED: 'PARSING_STOPPED',
  
  // Errors
  ERROR: 'ERROR',
  PARSER_ERROR: 'PARSER_ERROR',
};

// Helper functions
export const getParserAppEndpoint = (topic) => {
  return PARSER_TOPICS.APP_ENDPOINT_BASE + topic;
};

export const getParserUserQueueTopic = (topic) => {
  return PARSER_TOPICS.USER_QUEUE_BASE + topic;
};